module.exports = __webpack_public_path__ + "img/pdf2.4a850ed2.png";